<div class="min-h-screen flex justify-center items-center bg-gray-50 dark:bg-gray-900 font-[Segoe_UI,Tahoma,Geneva,Verdana,sans-serif] p-6 box-border">
  <router-outlet></router-outlet>
</div>
